// extracted by mini-css-extract-plugin
export default {"position_header":"PositionHeader_position_header__Fk0fD"};